
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widget_search",
      function () {
        return require("private-next-pages/widget_search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widget_search"])
      });
    }
  